import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { observer } from "mobx-react";
import { NOT_LOADED } from "../Infra/RemoteData";
import { addDisplayName } from "../Infra/display-name";
import { HXPage } from "./HXDesktopPage";
import { PermissionError } from "./HXDesktopPage.styles";
import { HXDesktopProjectDetails } from "./HXDesktopProjectDetails";
import { HXDesktopStudyHeaderView } from "./HXStudyHeaderView";
import { LoadingPlaceholder } from "./LoadingPlaceholder";
import { SiteStudyDetailsViewModel } from "./SiteStudyDetailsViewModel";
import { useViewModel } from "./useViewModel";
export const SiteStudyDetailsView = observer((props) => {
    const model = useViewModel(SiteStudyDetailsViewModel, props.container);
    if (model.study === NOT_LOADED) {
        return _jsx(LoadingPlaceholder, { w: 10, h: 60 });
    }
    if (model.study === null) {
        return _jsx(PermissionError, { children: "Study does not exist" });
    }
    return (_jsxs(HXPage, { children: [_jsx(HXDesktopStudyHeaderView, { study: model.study, showTeamMembers: false, onBack: () => model.onBack(), customBackText: "Back to projects", showShareRecruitmentButton: model.showShareRecruitmentButton }), _jsx(HXDesktopProjectDetails, { study: model.study, container: props.container })] }));
});
addDisplayName(SiteStudyDetailsView, "SiteStudyDetailsView");
